import { FormFieldWidget, ModelFieldType, SPI, ViewType, Widget, DetailNumberWidget } from '@kunlun/dependencies';
import { removeDecimalZero } from '../../../utils/number';

@SPI.ClassFactory(
  FormFieldWidget.Token({
    viewType: [ViewType.Detail],
    multi: false,
    ttype: [ModelFieldType.Float, ModelFieldType.Currency]
  })
)
export class RemoveZeroDetailNumberWidget extends DetailNumberWidget {
  @Widget.Reactive()
  protected get currentValue() {
    return removeDecimalZero(super.currentValue);
  }
}
